"use client";

import Link from "next/link";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { useAdminStatus } from "@/lib/admin/useAdminStatus";

/**
 * HeaderNavigation component
 * Client component that wraps navigation items (bell icon, My Posts link)
 * Conditionally hides navigation items when in admin mode (FR-4.2, FR-5.4)
 */
export function HeaderNavigation() {
  const { isAdmin, loading } = useAdminStatus();

  // Don't render navigation items while checking admin status or when in admin mode
  if (loading || isAdmin) {
    return null;
  }

  return (
    <>
      <Link
        href="/my-posts"
        className="text-sm text-[#707090] hover:text-white transition-colors font-medium px-2 py-1.5"
        aria-label="My Posts"
      >
        My Posts
      </Link>
      <NotificationBell />
    </>
  );
}
